import { render, staticRenderFns } from "./TkRefund.vue?vue&type=template&id=1cab051a&scoped=true&"
import script from "./TkRefund.vue?vue&type=script&lang=js&"
export * from "./TkRefund.vue?vue&type=script&lang=js&"
import style0 from "./TkRefund.vue?vue&type=style&index=0&id=1cab051a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cab051a",
  null
  
)

export default component.exports